<ftr-page>
  <article class="under-construction">
    <div class="card card--borderless">
      <div class="under-construction__illustration">
        <ftr-illustration [illustration]="illustration.CourtSystem" />
      </div>
      <h1 class="under-construction__title">{{ title() }}</h1>
      <p class="under-construction__message">{{ message() }}</p>
    </div>
  </article>
</ftr-page>
